<div class="talent-app-container grid-container full">
  <router-outlet></router-outlet>
</div>
